module.exports = __webpack_public_path__ + "static/media/logo-talisis-rojo.b1cf4b46.png";